/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetUsersResponseDataUsersInnerUserAvatar
 */
export interface GetUsersResponseDataUsersInnerUserAvatar {
  /**
   *
   * @type {string}
   * @memberof GetUsersResponseDataUsersInnerUserAvatar
   */
  url?: string
}

export function GetUsersResponseDataUsersInnerUserAvatarFromJSON(json: any): GetUsersResponseDataUsersInnerUserAvatar {
  return GetUsersResponseDataUsersInnerUserAvatarFromJSONTyped(json, false)
}

export function GetUsersResponseDataUsersInnerUserAvatarFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetUsersResponseDataUsersInnerUserAvatar {
  if (json === undefined || json === null) {
    return json
  }
  return {
    url: !exists(json, 'url') ? undefined : json['url']
  }
}

export function GetUsersResponseDataUsersInnerUserAvatarToJSON(
  value?: GetUsersResponseDataUsersInnerUserAvatar | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    url: value.url
  }
}
